import React from "react";
import { Link } from "react-router-dom";
import "./blog.css";

const Person = () => {
  return (
    <div className="blog">
      <div className="container">
        <div className="content">
          <Link to="/writings" className="back-link">
            ← back to writings
          </Link>
          <div className="blog-header-row">
            <div className="flex gap-4 items-center flex-row">
              <h1>the person you want to surround yourself with</h1>
            </div>
            <p className="blog-date">2026-05-10</p>
          </div>
          <div className="border-b border-gray-400 text-gray-700 py-2">
            there is an objective good human being!! i really want to be that way
          </div>
          <div className="blog-content">
            <div className="blog-body">
              <p>
                I believe there exists an objective best human being, a type of person you want in all of your relationships: business, friends, romantic. Of course, people can exhibit humility, kindness, understanding, etc; but I think those traits are downstream of one characteristic: self-awareness.
              </p>

              <p>
                I don't mean the social-radar kind—like reading a room, reading a relationship—but the developmental kind: understanding your own mind and how it got built. Someone with that ends up with every "good" trait on the list naturally, sort of through first principles.
              </p>

              <p>
                "But I'm self-aware." Maybe. Maybe not. The fact is there are levels — "orders of mind" — and most adults (around 60%) sit in order 3 or 4. The person I'm describing is order 5.
              </p>

              <p>
                The earliest is the impulsive mind (orders 1–2): kids acting on instinct through their physiological needs. The saying goes a toddler would sell their parents for a cold drink on a hot day.
              </p>

              <p>
                The next is the socialized mind (order 3), and most adults stop here. They absorb the values of their environment — religion, family, class — and follow them without ever asking whether they actually believe them. I always give the example of that same kid now in elementary school realizing that, despite their gassy meal from snack time, they have to resist the urge to fart in front of their class to maintain the social norm.
              </p>

              <p>
                Obviously, this scales up for adults, but even for them, there exist problems starting from communication. If you were to challenge a 3 you get outburst or submission, there isn't necessarily an in-between. They're the boss who can't take feedback and the friend who has nothing to say once the conversation goes past the surface. They've just never questioned much, so when something they "believe" gets poked, there's no internal structure underneath.
              </p>

              <p>
                Order 4 is "self-authoring": you realize what you call your beliefs are mostly assumed from your developmental years, simply following what the "adults" in your life told you. It takes a more curious mind to reframe this into an opportunity, but if you do you'll be on the path to figure out what you actually want and act on it.
              </p>

              <p>
                Order 5 turns the same insight outward. Every other person is also likely running inherited beliefs, and is mostly doing the best they can with what they got. This produces real compassion (not the performed kind) and, more importantly, real curiosity. Rather than recoiling from a disagreement, a 5 would walk into it: this is an idea outside my current model — maybe it fits better than what I have. Good communication isn't a separate trait they happen to have; it comes from the awareness. They communicate to listen and get challenged on their own beliefs, in absolutely any conversation with anyone. They've internalized the fact that, as stated, everyone is really just trying to do the best given their initial conditions in life—everyone's perspective is valid if you look at it this way.
              </p>

              <p>
                How do you find them? They're already everywhere!! The tell is how they talk about their own life. Someone who chose their actual calling — not their parents' calling for them — speaks differently about it. They've realized that they have their own beliefs and through the process of talking to others and expanding their world model, they've further figured out who they want to be. They couldn't imagine doing anything else; this is their normal. To others, it typically looks like they are amazingly successful. A body builder may wake up at 5am every single day which seems like it requires immense discipline to others, but for them they can't imagine a life not like this.
              </p>

              <p>
                Of course, not all successful people are self-aware, but what I'm saying is, people who are self-aware likely seem successful / incredibly interesting to you, or at least clearly on the path to getting there.
              </p>

              <p className="blog-dm-text">
                pls lmk if i am spreading misinformation about adult development i may have gotten stuff wrong
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Person;
